import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import axios from 'axios';
// import { decode } from 'html-entities';
// import moment from 'moment';

export class EventRegistrationSidebar extends Component  {
  // state = { isLoaded: false, registration: null }

  constructor(props) {
    console.dir(props);
    super(props);
    this.state = { isLoaded: false, registration: null, fn: '', ln: '', em: '', regComplete: false };
  }

  componentDidMount() {
    // console.dir(this.props);
    // const regStatus = (this.props.event.has_registration_opened === true && this.props.event.has_registration_closed === false) ? 'open' : 'closed';
    const regStatus = (this.props.event.registration === false) ? false : (this.props.event.has_registration_opened === true && this.props.event.has_registration_closed === false) ? 'open' : 'closed';

    this.setState({ registration: regStatus, isLoaded: true });
    setTimeout(() => { this.setupForm() }, 100);
  }

  setupForm = () => {
    const inputs = document.querySelectorAll('form input');
    inputs.forEach((i) => {
      i.addEventListener('change', function() {
        if (i.id === 'first_name') {
          this.setState({ fn : 'valid' });

          if (i.value === '') {
            this.setState({ fn : null });
          }
        }

        if (i.id === 'last_name') {
          this.setState({ ln : 'valid' });

          if (i.value === '') {
            this.setState({ ln : null });
          }
        }

        if(i.id === 'email') {
          if ( this.validateEmail(i.value) === true) {
            this.setState({ em : 'valid' });
          } else {
            this.setState({ em : null });
          }

          if (i.value === '') {
            this.setState({ em : null });
          }
        }

        this.validateForm();
      }.bind(this))
      // });
    });
  }

  validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateForm = () => {
    if (this.state.fn === 'valid' && this.state.ln === 'valid' && this.state.em === 'valid') {
      document.querySelector('button[type="submit"]').disabled = false;
    } else {
      document.querySelector('button[type="submit"]').disabled = true;
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    // console.dir(e);
    const libcalAPI = process.env.REACT_APP_LIBCALAPI;

    const body = {
      'grant_type': 'client_credentials',
      'client_id': process.env.REACT_APP_CLIENTID,
      'client_secret': process.env.REACT_APP_CLIENTSECRET
    };

    axios.post(libcalAPI+'/oauth/token', body)
    .then(res => {
      let token = res.data.access_token;
      // console.log(token);
      let regType = (this.props.event.online_seats > 0) ? 'online' : 'in-person';

      let regInfo = {
        'seats': 1,
        'waitlist': 1,
        'no_email': 0,
        'registration_type': regType,
        'form': {
            'first_name': e.target[0].value,
            'last_name':  e.target[1].value,
            'email':  e.target[2].value
        }
      }
      // console.dir(regInfo);

      axios.post('https://usa.libcal.com/api/1.1/events/' + this.props.event.id + '/register', regInfo, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(res => {
        console.dir(res);

        if (res.data.is_waitlist === true) {
          this.setState({ regComplete: 'waitlist', registration: 'complete' });
        } else {
          this.setState({ regComplete: true, registration: 'complete' });
        }
      })
      .catch(error => {
        console.dir(error);
        let status = error.response.status;

        if (status === 400) {
          this.setState({ regComplete: 'already', registration: 'complete' });
        } else {
          this.setState({ regComplete: false });
        }
      });
    });
  }

  render() {
    const { isLoaded, registration, fn, ln, em, regComplete } = this.state;
    // console.dir(this.state);

    return (
      <>
        <section className="eventRegistration">
          <h3>Register for Event</h3>
          {this.props.event.seats && (
            <p><i className="fa fa-users"></i> <span>{ this.props.event.seats - this.props.event.seats_taken }</span> of <span>{ this.props.event.seats }</span> seats available</p>
          )}

          {(isLoaded && registration === 'open') && (
            <form onSubmit={ this.submitForm.bind(this) }>

              <div className="form-input">
                <label htmlFor="first_name"></label>
                <input name="first_name" id="first_name" placeholder="First Name" className="form-input" />
              </div>

              <div className="form-input">
                <label htmlFor="last_name"></label>
                <input name="last_name" id="last_name" placeholder="Last Name" className="form-input" />
              </div>

              <div className="form-input">
                <label htmlFor="email"></label>
                <input name="email" id="email" placeholder="USA Email Address" className="form-input" />
              </div>

              <div className="errors">
                {fn === null  && ( <p id="error_fn">Please fill in your first name.</p> )}
                {ln === null  && ( <p id="error_ln">Please fill in your last name.</p> )}
                {em === null  && ( <p id="error_em">Please fill in your valid email address.</p> )}
              </div>

              <button type="submit" className="btn btn-primary" disabled>Register Now</button>

            </form>
          )}

          {(isLoaded && registration === 'closed') && (
            <p>Registration for this event is closed or full at this time.</p>
          )}

          {(isLoaded && registration === false) && (
            <p>Registration is not required for this event.</p>
          )}

          {(regComplete === true) && (
            <p>You have been <strong>registered</strong> for the event. You should recieve an email with more information and the link to the event. <br /><br />You can also email iLEARN (<a href="mailto:ilearn@usa.edu">ilearn@usa.edu</a>) for more information.</p>
          )}

          {(regComplete === 'waitlist') && (
            <p>You have been added to the <strong>wait list</strong> for the event. You should recieve an email with more information and the link to the event. <br /><br />You can also email iLEARN (<a href="mailto:ilearn@usa.edu">ilearn@usa.edu</a>) for more information.</p>
          )}

          {(regComplete === 'already') && (
            <p><strong>Sorry, you have already registered for this event!</strong> Check your email for the event info, or email iLEARN (<a href="mailto:ilearn@usa.edu">ilearn@usa.edu</a>) for more information.</p>
          )}
        </section>
      </>
    );
  }
}

export default EventRegistrationSidebar;